import type { AudioPlayerOptions } from './AudioPlayer.type';
import { PLAYER_MODE } from './AudioPlayer.type';

/** Classic preset — matches the original production player (inline play + progress, no skip buttons, gray) */
const classic: Required<AudioPlayerOptions> = {
  playerMode: PLAYER_MODE.CLASSIC,
  showThumbnail: true,
  showTitle: true,
  showRewind: false,
  showForward: false,
  rewindSeconds: 10,
  forwardSeconds: 15,
  primaryColor: '#6b7280',
  secondaryColor: '#d1d5db',
  backgroundColor: 'rgba(128, 128, 128, 0.15)',
  textColor: '',
  trackColor: 'rgba(128, 128, 128, 0.3)',
  iconColor: '',
  playButtonSize: 32,
  skipButtonSize: 28,
  waveformHeight: 48,
  progressBarHeight: 8,
};

/** Waveform preset — full waveform visualization with skip controls */
const waveform: Required<AudioPlayerOptions> = {
  playerMode: PLAYER_MODE.WAVEFORM,
  showThumbnail: true,
  showTitle: true,
  showRewind: true,
  showForward: true,
  rewindSeconds: 10,
  forwardSeconds: 15,
  primaryColor: '#6b7280',
  secondaryColor: '#d1d5db',
  backgroundColor: 'rgba(128, 128, 128, 0.15)',
  textColor: '',
  trackColor: 'rgba(128, 128, 128, 0.3)',
  iconColor: '',
  playButtonSize: 36,
  skipButtonSize: 28,
  waveformHeight: 48,
  progressBarHeight: 8,
};

const detailed: Required<AudioPlayerOptions> = {
  ...waveform,
  playerMode: PLAYER_MODE.DETAILED,
  showRewind: false,
  showForward: false,
  backgroundColor: 'transparent',
  primaryColor: '#030712',
  secondaryColor: '#d4d4d4',
  textColor: '#030712',
  playButtonSize: 64,
  waveformHeight: 64,
};

export const THEME_PRESETS = { classic, waveform, detailed } as const;

/** Resolve options by merging user overrides onto a theme preset */
export function resolveOptions(options?: AudioPlayerOptions): Required<AudioPlayerOptions> {
  const mode = options?.playerMode ?? PLAYER_MODE.CLASSIC;
  const preset = THEME_PRESETS[mode];
  return { ...preset, ...stripUndefined(options) };
}

function stripUndefined(obj?: Record<string, unknown>): Record<string, unknown> {
  if (!obj) return {};
  return Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== undefined));
}
